const returningToMsg = 'Returning to Sydney - Your Virtual Assistant';
/**
 * This is the baseline live chat banner config.
 * @summary
 * ! Important do not edit this config with client customizations!
 * Custom client config changes should be made in src/personas/config/appConfigMain
 * @see appConfigMain
*/
const defaultConfig = {
    start: {
        main: {
            text: 'Waiting for Representative',
        },
    },
    joined: {
        main: {
            text: 'Connected to Live Chat',
        },
        sub: {
            text: 'Customer Service Representative: ',
        },
    },
    ended: {
        user: {
            main: {
                text: 'Customer ended Live Chat',
            },
            sub: {
                text: returningToMsg,
            },
        },
        agent: {
            main: {
                text: 'Operator ended Live Chat',
            },
            sub: {
                operatorLefttext: ' has left the conversation',
                text: returningToMsg,
            },
        },
        timeout: {
            main: {
                text: 'Live Chat ended due to inactivity',
            },
            sub: {
                text: 'Returning to Sydney. Your Live Chat was disconnected due to inactivity',
            },
        },
        error: {
            main: {
                text: 'Error ended Live Chat',
            },
            sub: {
                text: returningToMsg,
            },
        },
    },
    defaultRepName: 'Operator',
};
export default defaultConfig;
